import { render } from "./rfp-iframe-error.vue?vue&type=template&id=62d6add8&scoped=true"
import script from "./rfp-iframe-error.vue?vue&type=script&lang=js"
export * from "./rfp-iframe-error.vue?vue&type=script&lang=js"

import "./rfp-iframe-error.vue?vue&type=style&index=0&id=62d6add8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d6add8"]])

export default __exports__